import { Component } from "react";
import { FaStar} from "react-icons/fa"
import { NavLink } from "react-router-dom";

const AnimePopular = ({ res }) =>{
    return(
        <div className="flex">
            <NavLink to="/view" className="m-5 rounded-xl w-56 sm:border-none sm:hover:border border-[rgb(48,54,68)] border-[0.0625rem] shadow-xl ">
                <div className="">
                    <img src={res.images.jpg.image_url} alt="" className="z-10 rounded-[12px]" />
                </div>
                
                <div className="z-100 -mt-[100px] card-holder h-32 bg-gray-800 shadow-black">
                    <div className="flex p-4 font-bold flex-col">
                        <div className="flex ml-3 items-center justify-center -mt-10 bg-red-600 rounded-full h-14  w-14">
                            #<span className="text-4xl">{res.popularity}</span>
                        </div>
                        <div className="flex flex-col h-full ">
                            <div className="mt-2 text-sm">
                                {res.title}
                            </div>
                            <div className="flex items-center self-start gap-2 mt-1 rounded-xl bg-gray-700 px-2 ">
                                <FaStar/> {res.score}
                            </div>
                        </div>
                    </div>
                </div>
            </NavLink>
            <div className="m-5 hidden sm:block rounded-xl w-full pr-3 shadow-xl">
                <div className="bg-gray-800 h-full rounded-xl flex">
                    <div className="bg-gray-600 w-4 rounded-xl rounded-br-none card_pop relative">
                    </div>
                    <div className="p-4 px-6">
                        <div>
                            <h1 className="text-2xl font-semibold">{res.title}</h1>
                        </div>
                        <div className="flex my-2">
                            {res.genres.map((x)=> (
                            <div className="bg-[#096BDB] select-none mx-1 rounded-xl px-2 hover:bg-gray-900 hover:text-gray-200 line-clamp-1 text-sm" key={x.name}>{x.name}</div>
                                ))}
                        </div>
                        <div>
                            <p className="line-clamp-5 indent-16 text-gray-400">{res.synopsis}</p>
                            <div className="text-center"><NavLink to="/view" className="underline underline-offset-1 decoration-sky-500 decoration-0 hover:decoration-2 ">Read More</NavLink></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AnimePopular;